<template>
  <el-drawer v-model="drawer" title="编辑银行卡" size="40%" :direction="direction" :before-close="handleClose">
    <el-form v-if="addRow" ref="editBankForm" :inline="true"  :model="addRow" label-width="100px">
      <form-item-rule   label="开户人" prop="userName">
        <el-input placeholder="请输入公司名称" class="w300" v-model="addRow.userName"></el-input>
      </form-item-rule>
      <form-item-rule   label="开户银行" prop="type">
        <el-input placeholder="请输入公司名称" class="w300" v-model="addRow.type"></el-input>
      </form-item-rule>
      <form-item-rule   label="开户支行" prop="name">
        <el-input placeholder="请输入公司名称" class="w300" v-model="addRow.name"></el-input>
      </form-item-rule>
      <form-item-rule   label="银行卡号" prop="bankCode">
        <el-input placeholder="请输入公司名称" class="w300" v-model="addRow.bankCode"></el-input>
      </form-item-rule>
      <form-item-rule   label="是否默认" prop="isDefault" class="w300" >
        <el-radio-group v-model="addRow.isDefault">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </form-item-rule>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "org-bank-edit",
  components: {FormItemRule},
  data() {
    return {
      drawer:false,
      direction:"rtl",
      addRow:{id:"",userName:"",type:"",name:"",bankCode:"",isDefault:0}
    }
  },
  mixins: [tableBase],
  methods: {
    openDrawer(id){
      this.drawer = true;
      this.addRow = {id:"",userName:"",type:"",name:"",bankCode:"",isDefault:0};
      if($.isNotEmpty(id)){
        this.findDetail(id);
      }
    },
    findDetail(id){
      this.simpleGet("/api/mgr/business/shop/money/info/bankDetail",{id:id},result=>{
        this.addRow = result.data;
      })
    },
    save(){
      this.$refs['editBankForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/shop/money/info/bankEdit",this.addRow,result=>{
            this.message("保存成功");
            this.$emit("success");
            this.handleClose();
          })
        }
      })
    },
    handleClose(){
      this.drawer = false;
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
